// 介面語言共用工具
// why：語言切換原本只改 this.$i18n.locale，重整就沒了——醫師在檢查中途按到
// 重整或換頁重載，介面會自己跳回醫院預設語系。這支把「初值解析 / 持久化 /
// 套用 <html lang>」收斂成單一真相源，讓 main.js 開機與 App.vue 的地球選單
// 共用同一份邏輯，避免兩處判斷漂移。結構刻意與 utils/theme.js 對齊。

export const LOCALE_STORAGE_KEY = 'evas-locale'

// 與 locale/index.js 註冊的 messages 對應。順序即地球選單的顯示順序。
export const SUPPORTED_LOCALES = ['zh', 'en', 'ja']

// 沒有任何線索時的最終退路。EVAS2.0 預設中文介面。
export const DEFAULT_LOCALE = 'zh'

export function isSupportedLocale (locale) {
  return SUPPORTED_LOCALES.includes(locale)
}

// 解析開機初值，優先序：
//   1. localStorage 持久值——醫師曾手動選過，一律以使用者選擇為準
//   2. 醫院別 runtime config 的 locale.default（/api/config/runtime）
//   3. DEFAULT_LOCALE
// why：醫院配置只當「這台機器沒人選過時的首次預設」。原本 main.js 是無條件
// 用醫院配置覆寫，導致使用者切了語言、重整後又被醫院預設蓋回去。
export function resolveInitialLocale (hospitalDefault) {
  try {
    const saved = window.localStorage.getItem(LOCALE_STORAGE_KEY)
    if (isSupportedLocale(saved)) return saved
  } catch (e) {
    // localStorage 不可用（隱私模式等）→ 落到醫院預設
  }
  if (isSupportedLocale(hospitalDefault)) return hospitalDefault
  return DEFAULT_LOCALE
}

// 持久化使用者選擇（只有「使用者主動切換」才呼叫；開機 seed 不持久化，
// 好讓醫院配置在使用者尚未明確選擇前仍能生效）
export function persistLocale (locale) {
  try {
    window.localStorage.setItem(LOCALE_STORAGE_KEY, locale)
  } catch (e) {
    // 無法持久化不影響當次切換，忽略
  }
}

// 同步 <html lang>。螢幕閱讀器靠它選發音語系，瀏覽器靠它決定要不要跳翻譯提示。
// vue-i18n 只換字串、不會動 DOM 屬性，所以得自己來。
export function applyDocumentLang (locale) {
  if (typeof document === 'undefined' || !document.documentElement) return
  document.documentElement.setAttribute('lang', locale)
}
